import { ROUTES } from './routes.js';

export const NAVIGATION = [
  {
    label: 'Principale',
    items: [
      { label: 'Dashboard', to: ROUTES.dashboard, icon: '⌂' }
    ]
  },
  {
    label: 'Rete PDV',
    items: [
      { label: 'PDV attivi', to: ROUTES.pdvActive, icon: '●' },
      { label: 'Master PDV', to: ROUTES.pdvMaster, icon: '◎' },
      { label: 'Mappa', to: ROUTES.map, icon: '⌖' }
    ]
  },
  {
    label: 'Operatività',
    items: [
      { label: 'Planning', to: ROUTES.planning, icon: '▦' },
      { label: 'Visite', to: ROUTES.visits, icon: '✓' },
      { label: 'Vendite', to: ROUTES.sales, icon: '↗' },
      { label: 'Segnalazioni', to: ROUTES.issues, icon: '!' },
      { label: 'Report', to: ROUTES.reports, icon: '▤' }
    ]
  },
  {
    label: 'Amministrazione',
    items: [
      { label: 'Utenti e ruoli', to: ROUTES.users, icon: '♙' },
      { label: 'File e import', to: ROUTES.imports, icon: '⇩' },
      { label: 'Registro attività', to: ROUTES.audit, icon: '≡' }
    ]
  },
  {
    label: 'Account',
    items: [
      { label: 'Il mio account', to: ROUTES.account, icon: '○' }
    ]
  }
];
